module.exports = __webpack_public_path__ + "static/media/raw.ffcc63a6.svg";